var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"hidden"},[_vm._v("\n  Signing out, you will be redirected.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }